import React, { useEffect, useState } from 'react';

const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Default: light — ใช้ค่าที่บันทึกไว้ หรือ 'light'
    return localStorage.getItem('theme') || 'light';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () =>
    setTheme(prev => (prev === 'light' ? 'dark' : 'light'));

  const isDark = theme === 'dark';

  return (
    <React.Fragment>
      {children}

      {/* ── Toggle button – มุมบน-ขวา ───────────────────────── */}
      <button
        onClick={toggleTheme}
        title={isDark ? 'สลับโหมดสว่าง' : 'สลับโหมดมืด'}
        style={{
          position: 'fixed',
          top: 14,
          right: 16,
          zIndex: 10000,
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          padding: '6px 12px',
          borderRadius: 9999,
          border: isDark ? '1px solid rgba(255,255,255,0.12)' : '1px solid #e2e8f0',
          background: isDark ? 'rgba(30,41,59,0.90)' : 'rgba(255,255,255,0.90)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          cursor: 'pointer',
          boxShadow: isDark
            ? '0 2px 12px rgba(0,0,0,0.40)'
            : '0 2px 10px rgba(0,0,0,0.10)',
          transition: 'all 200ms cubic-bezier(0.4,0,0.2,1)',
          fontSize: 13,
          fontWeight: 600,
          color: isDark ? '#e2e8f0' : '#475569',
          fontFamily: 'inherit',
          lineHeight: 1,
        }}
      >
        {/* icon */}
        <span style={{ fontSize: 15, lineHeight: 1 }}>
          {isDark ? '☀️' : '🌙'}
        </span>
        {/* label */}
        <span style={{ letterSpacing: '0.01em' }}>
          {isDark ? 'Light' : 'Dark'}
        </span>
      </button>
    </React.Fragment>
  );
};

export default ThemeProvider;
